module.exports = __webpack_public_path__ + "img/airplane-ticket.f22f8525.webp";